import React, { useState } from "react";
import '@/css/auth.css';
import DiscordOAuth from "./DiscordOAuth";
import PhoneVerification from "./Phone";

const Register = ({ onComplete }: { onComplete: () => void }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [discordId, setDiscordId] = useState("");
  const [discordAvatar, setDiscordAvatar] = useState("");

  const handleDiscordSuccess = (data: {
    email: string;
    username: string;
    discordId: string;
    discordAvatar: string;
  }) => {
    setEmail(data.email);
    setUsername(data.username);
    setDiscordId(data.discordId);
    setDiscordAvatar(data.discordAvatar);
    setStep(2);
  };

  return (
    <div className="content-wrapper">
      {step === 1 && <DiscordOAuth onSuccess={handleDiscordSuccess} />}
      {step === 2 && (
        <PhoneVerification
          email={email}
          username={username}
          discordId={discordId}
          discordAvatar={discordAvatar}
          nextStep={onComplete}
        />
      )}
    </div>
  );
};

export default Register;
